import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-dark" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_4 = { class: "btn btn-light mr-2" }
const _hoisted_5 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "mt-5 font-weight-light" }
const _hoisted_9 = { class: "text-lowercase" }
const _hoisted_10 = { class: "lead" }
const _hoisted_11 = { class: "navbar navbar-expand-md navbar-light bg-light" }
const _hoisted_12 = { class: "navbar-nav" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "table table-hover mt-3" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  class: "progress",
  style: {"height":"30px"}
}
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "btn btn-outline-primary" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "table table-hover mt-3" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = {
  class: "progress",
  style: {"height":"30px"}
}
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "btn btn-outline-primary" }
const _hoisted_31 = {
  key: 1,
  class: "container"
}
const _hoisted_32 = {
  key: 2,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_33 = { class: "card" }
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "btn btn-secondary" }
const _hoisted_36 = {
  key: 3,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "card-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionDetailsDialog = _resolveComponent("CriterionDetailsDialog")!
  const _component_AlternativeDetailsDialog = _resolveComponent("AlternativeDetailsDialog")!
  const _component_PanelistConsistencyAnalysisDialog = _resolveComponent("PanelistConsistencyAnalysisDialog")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionDetailsDialog, { viewModel: _ctx.criterionDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AlternativeDetailsDialog, { viewModel: _ctx.alternativeDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_PanelistConsistencyAnalysisDialog, {
      propOpened: _ctx.panelistConsistencyAnalysisOpened === true,
      propRm: _ctx.panelistConsistencyAnalysis,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.panelistConsistencyAnalysisOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm"]),
    (_ctx.viewTemplate === 'default')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("nav", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("form", _hoisted_3, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Join Meeting", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, _ctx.meetingUrl]
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light dropdown-toggle",
                    "data-toggle": "dropdown"
                  }, " My votes ", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showRespondentConsistencyAnalysis && _ctx.showRespondentConsistencyAnalysis(...args)))
                    }, "Check consistency"),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleExportPanelistVotesToXlsCommand && _ctx.handleExportPanelistVotesToXlsCommand(...args)))
                    }, "Download to xls")
                  ])
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("a", {
                  class: "btn btn-light",
                  href: "https://www.transparentchoice.com/user-guide/respondents-scoring",
                  title: "Respondents guide: Scoring Projects",
                  target: "_blank"
                }, [
                  _createElementVNode("i", {
                    class: "fa fa-info",
                    "aria-hidden": "true"
                  })
                ], -1 /* CACHED */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, "Survey: " + _toDisplayString(_ctx.surveyName), 1 /* TEXT */),
            _createElementVNode("p", null, [
              _createTextVNode(" Evaluate " + _toDisplayString(_ctx.Alternatives.length) + " ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.alternativesLabel), 1 /* TEXT */),
              _createTextVNode(" in the context of " + _toDisplayString(_ctx.Criteria.length) + " criteria by answering " + _toDisplayString(_ctx.surveyQuestionsCount) + " questions. ", 1 /* TEXT */)
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.surveyDescription), 1 /* TEXT */),
            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("nav", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", _hoisted_13, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    role: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ToggleViewByCommand && _ctx.ToggleViewByCommand(...args)))
                  }, " View by: " + _toDisplayString(_ctx.ViewByLabel), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("form", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control mr-sm-2",
                  type: "search",
                  placeholder: "Search...",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.SearchPhrase]
                ])
              ])
            ]),
            (_ctx.ByAlternative === true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("table", _hoisted_16, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */),
                        _createElementVNode("th", null, [
                          _createElementVNode("a", {
                            class: "pointer",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.ToggleOrderByProgressCommand && _ctx.ToggleOrderByProgressCommand(...args)))
                          }, "Progress")
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("th", { style: {"width":"120px"} }, null, -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AlternativesView, (a) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: a.Id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              class: "text-dark",
                              onClick: ($event: any) => (_ctx.showAlternativeDetailsDialog(a))
                            }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_17)
                          ]),
                          _createElementVNode("td", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", {
                                class: "progress-bar",
                                role: "progressbar",
                                style: _normalizeStyle({ width: a.Progress + '%' }),
                                title: a.Progress
                              }, null, 12 /* STYLE, PROPS */, _hoisted_20)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_21, [
                            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_22, [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("Evaluate", -1 /* CACHED */)
                            ]))])), [
                              [_directive_sanitizedHref, `/#/scoring/alternative/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}/${a.Id}`]
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.ByAlternative === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("table", _hoisted_24, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[12] || (_cache[12] = _createElementVNode("th", null, "Criterion", -1 /* CACHED */)),
                        _createElementVNode("th", null, [
                          _createElementVNode("a", {
                            class: "pointer",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ToggleOrderByProgressCommand && _ctx.ToggleOrderByProgressCommand(...args)))
                          }, "Progress")
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("th", { style: {"width":"120px"} }, null, -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CriteriaView, (c) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: c.Id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              class: "text-dark",
                              onClick: ($event: any) => (_ctx.showCriterionDetailsDialog(c))
                            }, _toDisplayString(c.Name), 9 /* TEXT, PROPS */, _hoisted_25),
                            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                            _createElementVNode("small", null, _toDisplayString(c.Path), 1 /* TEXT */)
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", {
                                class: "progress-bar",
                                role: "progressbar",
                                style: _normalizeStyle({ width: c.Progress + '%' }),
                                title: c.Progress
                              }, null, 12 /* STYLE, PROPS */, _hoisted_28)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_29, [
                            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_30, [...(_cache[15] || (_cache[15] = [
                              _createTextVNode("Evaluate", -1 /* CACHED */)
                            ]))])), [
                              [_directive_sanitizedHref, `/#/scoring/criterion/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}/${c.Id}`]
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[17] || (_cache[17] = [
          _createElementVNode("h3", { class: "text-center" }, [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
            _createTextVNode(" Loading...")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'closed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "card-title" }, "Survey is closed", -1 /* CACHED */)),
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "card-text lead" }, "Please wait for the host to open this survey or go to the meeting.", -1 /* CACHED */)),
              _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_35, [...(_cache[18] || (_cache[18] = [
                _createTextVNode("Go to the meeting", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.meetingUrl]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.viewTemplate === 'empty')
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h5", _hoisted_39, "Empty survey: " + _toDisplayString(_ctx.surveyName), 1 /* TEXT */),
              _cache[22] || (_cache[22] = _createElementVNode("p", { class: "card-text lead" }, "Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice.", -1 /* CACHED */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}